/* LK — shared behaviour: rotating search placeholder, wishlist (localStorage, per-browser),
   remembered pincode, hero carousel, menu/search panels. */
(function () {
  'use strict';
  var W = window;
  var LK = (W.LK = W.LK || {});
  /* Same guard as lk-ui.js: this file is included by several sections, and a
     second copy would double-fire every delegated click (hearts, panels, pin). */
  if (W.__LK_BOUND) return;
  W.__LK_BOUND = true;
  var reduced = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function store(key, val) {
    try { if (val === undefined) return JSON.parse(localStorage.getItem(key) || 'null'); localStorage.setItem(key, JSON.stringify(val)); }
    catch (e) { return null; }
  }

  /* ---- wishlist ---- */
  LK.wish = function () { return store('lk_wish') || []; };
  LK.wishCount = function () {
    var n = LK.wish().length;
    document.querySelectorAll('[data-lk-wish-count]').forEach(function (b) { b.textContent = n; b.hidden = n === 0; });
  };
  /* 25 Oct 2026: /pages/saved needs a handle per saved id (the storefront has no lookup by id), so every heart
     carries data-lk-heart-handle and the map lives in lk_wish_h. Saves made before today get their handle the
     next time a heart for that product is on screen. */
  LK.wishHandles = function () { return store('lk_wish_h') || {}; };
  function handleOf(h) {
    var hd = h.getAttribute('data-lk-heart-handle');
    if (!hd) { var card = h.closest('.lk-card'), qv = card && card.querySelector('[data-lk-qv]'); hd = qv ? qv.getAttribute('data-lk-qv') : ''; }
    return hd || '';
  }
  LK.paintHearts = function () {
    var w = LK.wish(), map = LK.wishHandles(), dirty = false;
    document.querySelectorAll('[data-lk-heart]').forEach(function (h) {
      var id = h.getAttribute('data-lk-heart'), on = w.indexOf(id) !== -1;
      h.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on && !map[id]) { var hd = handleOf(h); if (hd) { map[id] = hd; dirty = true; } }
    });
    if (dirty) store('lk_wish_h', map);
    LK.wishCount();
  };

  /* ---- search placeholder rotation ---- */
  function rotatePlaceholders() {
    document.querySelectorAll('[data-lk-placeholders]').forEach(function (input) {
      if (input.dataset.rotating === '1') return;
      input.dataset.rotating = '1';
      var list = (input.getAttribute('data-lk-placeholders') || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
      if (list.length < 2 || reduced) { if (list[0]) input.placeholder = 'Search "' + list[0] + '"'; return; }
      var i = 0;
      input.placeholder = 'Search "' + list[0] + '"';
      setInterval(function () {
        if (document.activeElement === input || input.value) return;
        i = (i + 1) % list.length;
        input.placeholder = 'Search "' + list[i] + '"';
      }, 2600);
    });
  }

  /* ---- pincode ---- */
  function pincode() {
    var saved = store('lk_pin');
    document.querySelectorAll('[data-lk-pin-label]').forEach(function (el) {
      if (saved) el.textContent = 'Deliver to ' + saved;
    });
  }

  /* ---- hero carousel ---- */
  function heroes() {
    document.querySelectorAll('[data-lk-hero]').forEach(function (host) {
      if (host.dataset.bound === '1') return;
      host.dataset.bound = '1';
      var track = host.querySelector('[data-lk-hero-track]');
      var slides = host.querySelectorAll('[data-lk-slide]');
      var dots = host.querySelectorAll('[data-lk-dot]');
      var n = slides.length;
      if (n < 2) return;
      var i = 0, timer = null;
      var wait = parseInt(host.getAttribute('data-interval'), 10) || 4500;
      function go(k) {
        i = ((k % n) + n) % n;
        track.scrollTo({ left: slides[i].offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
        dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function play() { stop(); if (!reduced && host.getAttribute('data-autoplay') === 'true') timer = setInterval(function () { go(i + 1); }, wait); }
      dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); stop(); }); });
      var prev = host.querySelector('[data-lk-prev]'), next = host.querySelector('[data-lk-next]');
      if (prev) prev.addEventListener('click', function () { go(i - 1); stop(); });
      if (next) next.addEventListener('click', function () { go(i + 1); stop(); });
      /* keep dots in sync with manual swipes */
      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var k = Math.round(track.scrollLeft / (slides[0].offsetWidth + 12));
          if (k !== i && k >= 0 && k < n) { i = k; dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); }); }
        }, 80);
      }, { passive: true });
      host.addEventListener('pointerdown', stop);
      host.addEventListener('mouseenter', stop);
      host.addEventListener('mouseleave', play);
      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : play(); });
      play();
    });
  }

  /* ---- rails: prev/next buttons ---- */
  function rails() {
    document.querySelectorAll('[data-lk-rail-nav]').forEach(function (btn) {
      if (btn.dataset.bound === '1') return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var rail = btn.closest('.lk-sec, section, div').querySelector('.lk-rail');
        if (!rail) return;
        var dir = btn.getAttribute('data-lk-rail-nav') === 'next' ? 1 : -1;
        rail.scrollBy({ left: dir * rail.clientWidth * 0.8, behavior: reduced ? 'auto' : 'smooth' });
      });
    });
  }

  /* ---- delegated clicks ---- */
  document.addEventListener('click', function (e) {
    var h = e.target.closest('[data-lk-heart]');
    if (h) {
      e.preventDefault();
      var id = h.getAttribute('data-lk-heart');
      var w = LK.wish(), map = LK.wishHandles();
      var at = w.indexOf(id);
      if (at === -1) { w.push(id); var hd = handleOf(h); if (hd) map[id] = hd; } else { w.splice(at, 1); delete map[id]; }
      store('lk_wish', w); store('lk_wish_h', map);
      LK.paintHearts();
      if (!reduced && h.animate) {
        h.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.28)' }, { transform: 'scale(.94)' }, { transform: 'scale(1)' }], { duration: 420, easing: 'cubic-bezier(.22,.61,.36,1)' });
        document.querySelectorAll('[data-lk-wish-count]').forEach(function (b) { if (!b.hidden && b.animate) b.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.35)' }, { transform: 'scale(1)' }], { duration: 360 }); });
      }
      return;
    }
    var tg = e.target.closest('[data-lk-toggle]');
    if (tg) {
      e.preventDefault();
      var panel = document.getElementById(tg.getAttribute('data-lk-toggle'));
      if (!panel) return;
      var open = panel.hasAttribute('hidden');
      document.querySelectorAll('[data-lk-panel]').forEach(function (p) { if (p !== panel) { p.setAttribute('hidden', ''); } });
      panel.toggleAttribute('hidden', !open);
      tg.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var f = panel.querySelector('input,a,button'); if (f) f.focus(); }
      return;
    }
    var pinSave = e.target.closest('[data-lk-pin-save]');
    if (pinSave) {
      e.preventDefault();
      var inp = pinSave.closest('form').querySelector('input');
      var v = (inp.value || '').replace(/\D/g, '').slice(0, 6);
      if (v.length === 6) { store('lk_pin', v); pincode(); var p = pinSave.closest('[data-lk-panel]'); if (p) p.setAttribute('hidden', ''); }
      else { inp.focus(); inp.setAttribute('aria-invalid', 'true'); }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-lk-panel]:not([hidden])').forEach(function (p) { p.setAttribute('hidden', ''); });
    document.querySelectorAll('[data-lk-toggle][aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  });

  /* ---- card photo rails: keep the dots in step with the swipe ---- */
  function cardRails() {
    document.querySelectorAll('[data-lk-card-rail]').forEach(function (rail) {
      if (rail.dataset.bound === '1') return;
      rail.dataset.bound = '1';
      var dots = rail.parentNode.querySelectorAll('[data-lk-card-dots] i');
      var t;
      rail.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var k = Math.round(rail.scrollLeft / (rail.clientWidth || 1));
          dots.forEach(function (d, j) { d.classList.toggle('on', j === k); });
        }, 60);
      }, { passive: true });
    });
  }

  function boot() { LK.paintHearts(); rotatePlaceholders(); pincode(); heroes(); rails(); cardRails(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
